const LocalStorage = {
    setItem: (key, value) => {
        localStorage.setItem(key, value);
        },

    getItem: (key) => {
        const value = localStorage.getItem(key);

        return value;
    },

    removeItem: (key) => {
        localStorage.removeItem(key);
    },

    clear: () => {
        localStorage.clear()
    }
};

export default LocalStorage;